import {
  DOWNLOAD_ADIB_BOOKING,
  DOWNLOAD_ADIB_BOOKING_SUCCESS,
  DOWNLOAD_ADIB_BOOKING_ERROR,
  DOWNLOAD_ADIB_BOOKING_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadAdibBookingDump = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_ADIB_BOOKING:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_ADIB_BOOKING_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_ADIB_BOOKING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_ADIB_BOOKING_EMPTY:
      state = {
        data: null,
        message: null,
        loading: false,
        success: false,
        error: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadAdibBookingDump;
